import {GLOBAL_CONFIG} from '@helpers/config-master.mjs';
import {useEffect} from 'react';

export const LoadAffirmScript = ({price, style, isDev = false}) => {
  const publicKey = AffirmGlobalConfigFrontEnd(isDev).affirmPublicApiKey;
  const scriptUrl = AffirmGlobalConfigFrontEnd(isDev).affirmScriptUrl;

  useEffect(() => {
    // Define affirm config object
    const affirmConfig = {
      public_api_key: publicKey,
      script: scriptUrl
    };

    // Declare affirm on window to avoid the undefined error
    window.affirm = window.affirm || {};

    (function (l, g, m, e, a, f, b) {
      let d,
        c = l[m] || {},
        h = document.createElement(f),
        n = document.getElementsByTagName(f)[0],
        k = function (a, b, c) {
          return function () {
            a[b]._.push([c, arguments]);
          };
        };
      c[e] = k(c, e, 'set');
      d = c[e];
      c[a] = {};
      c[a]._ = [];
      d._ = [];
      c[a][b] = k(c, a, b);
      a = 0;
      for (
        b = 'set add save post open empty reset on off trigger ready setProduct'.split(' ');
        a < b.length;
        a++
      )
        d[b[a]] = k(c, e, b[a]);
      a = 0;
      for (b = ['get', 'token', 'url', 'items']; a < b.length; a++) d[b[a]] = function () {
      };
      h.async = !0;
      h.src = g[f];
      n.parentNode.insertBefore(h, n);
      delete g[f];
      d(g);
      l[m] = c;
    })(window, affirmConfig, 'affirm', 'checkout', 'ui', 'script', 'ready');

    // Use window.affirm to ensure affirm is defined
    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(function () {
        window.affirm.ui.refresh();
      });
    }
  }, [publicKey, scriptUrl]); // Added dependencies

  if (!price) {
    return null;
  }

  const priceForAffirm = (price * 100).toFixed(0);

  return (
    <p
      className="affirm-as-low-as mt-1 text-[11.5px]"
      data-page-type="cart"
      data-amount={priceForAffirm}
    >
      {price} {priceForAffirm}
    </p>
  );
};

export const AffirmGlobalConfigFrontEnd = (isDev) => {
  GLOBAL_CONFIG.EnvType = isDev ? 'development' : 'production';

  const sandboxPublicKey = 'A21NXHP3J714KZJR';
  const livePublicKey = 'LBWU4AYG7VHQ579U';

  const sandboxScriptUrl = 'https://cdn1-sandbox.affirm.com/js/v2/affirm.js';
  const liveScriptUrl = 'https://cdn1.affirm.com/js/v2/affirm.js';

  if (isDev) {
    return {
      affirmPublicApiKey: sandboxPublicKey,
      affirmScriptUrl: sandboxScriptUrl
    };
  }
  return {
    affirmPublicApiKey: livePublicKey,
    affirmScriptUrl: liveScriptUrl
  };
};
